import {AiOutlineCheckCircle} from "react-icons/ai";
import {GoInfo} from "react-icons/go";
import {Link} from "react-router-dom";

export default function DailyItem({ item, text, link }) {
    const passed = item.completed >= item.required
    return <li className={passed ? 'completed' : ''}>
        {passed ? <AiOutlineCheckCircle /> : <GoInfo />}
        <Link to={link}>{item.completed}/{item.required} {text}</Link>
        <span>{item.points} Pts</span>
    </li>

}